import classNames from 'classnames';
import { DataScopeAccess, DataShareScopeView, DataShareStatus } from '../../../../types/dataShare';
import { InitiativeCompany } from '../../../../types/initiative';
import SimpleTooltip from '../../../simple-tooltip';
import { mergeScopeViews } from '../../../../utils/dataShare';
import { getViewAccess } from '../utils';

const ACCESS_TEXT_MAP = {
  [DataShareScopeView.Insights]: 'Insights',
  [DataShareScopeView.Downloads]: 'Downloads',
  [DataShareScopeView.Survey]: 'Full Survey access',
  [DataShareScopeView.Messaging]: 'Messaging',
};

export const getAccessHint = (company: InitiativeCompany) => {
  const shareScopeViewsAccess = getViewAccess(company);

  if (shareScopeViewsAccess === DataScopeAccess.None) {
    return (
      <div className='p-2'>
        <span>Not shared:</span>
        <br />
        <span>Insights, Downloads, Full Survey access, and Messaging.</span>
      </div>
    );
  }

  if (shareScopeViewsAccess === DataScopeAccess.Full) {
    return (
      <div className='p-2'>
        <span>Company is sharing:</span>
        <br />
        <span>Insights, Downloads, Full Survey access, and Messaging.</span>
      </div>
    );
  }

  const acceptedDataShares = (company.requestedDataShares ?? []).filter((item) => item.status === DataShareStatus.Accepted);
  const mergedScopeViews = mergeScopeViews(acceptedDataShares);

  if (shareScopeViewsAccess === DataScopeAccess.Partial) {
    const sharing = Object.values(DataShareScopeView)
      .filter((item) => mergedScopeViews.includes(item))
      .map((item) => ACCESS_TEXT_MAP[item])
      .join(', ');
    const notShared = Object.values(DataShareScopeView)
      .filter((item) => !mergedScopeViews.includes(item))
      .map((item) => ACCESS_TEXT_MAP[item])
      .join(', ');
    return (
      <div className='p-2'>
        <p className='mb-1'>
          <span>Company is sharing:</span>
          <br />
          <span>{sharing}</span>
        </p>
        <p className='mb-1'>
          <span>Not shared:</span>
          <br />
          <span>{notShared}</span>
        </p>
      </div>
    );
  }
};

interface AccessStatusProps {
  company: InitiativeCompany;
}
const AccessStatus = ({ company }: AccessStatusProps) => {
  return (
    <SimpleTooltip text={getAccessHint(company)}>
      <div className={classNames('access-status', getViewAccess(company))} />
    </SimpleTooltip>
  );
};

export default AccessStatus;
